import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { map } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);
    const params = new URLSearchParams(window.location.search);
    const bossToken = route.queryParams?.['token'] || params.get('token');
    const msisdn = route.queryParams?.['msisdn'] || params.get('msisdn');
    const userId = route.queryParams?.['userId'] || params.get('userId');

    if (bossToken) {
        if (msisdn) localStorage.setItem('msisdn', msisdn);
        if (userId) localStorage.setItem('userId', userId);

        // Validate token in iframe mode
        return authService.signInWithToken(bossToken, true).pipe(
            map((authenticatedWithBoss) => {
                if (authenticatedWithBoss) {
                    return true;
                }
                const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                return router.parseUrl(`sign-in?${redirectURL}`);
            })
        );
    }

    // Normal subscriber check
    return authService.check().pipe(
        map((authenticated) => {
            if (!authenticated) {
                const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                return router.parseUrl(`sign-in?${redirectURL}`);
            }
            return true;
        })
    );
};
